import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';

import SlotsConfigIndex from './SlotsConfig/Index.vue';
import KnowledgeBaseIndex from './KnowledgeBase/Index.vue';
import PendingQuestionsIndex from './PendingQuestions/Index.vue';
import BotDataSourcesIndex from './BotDataSources/Index.vue';
import BillingIndex from './Billing/Index.vue';
import BoletosIndex from './Boletos/Index.vue';
import WaCampaignsIndex from './WaCampaigns/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/omni'),
      name: 'omni_settings',
      meta: {
        permissions: ROLES,
      },
      redirect: to => {
        return { name: 'omni_slots_config', params: to.params };
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/omni/slots'),
      name: 'omni_slots_config',
      component: SlotsConfigIndex,
      meta: {
        permissions: ROLES,
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/omni/knowledge-base'),
      name: 'omni_knowledge_base',
      component: KnowledgeBaseIndex,
      meta: {
        permissions: ROLES,
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/omni/pending-questions'),
      name: 'omni_pending_questions',
      component: PendingQuestionsIndex,
      meta: {
        permissions: ROLES,
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/omni/data-sources'),
      name: 'omni_data_sources',
      component: BotDataSourcesIndex,
      meta: {
        permissions: ROLES,
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/omni-billing'),
      name: 'omni_billing',
      component: BillingIndex,
      meta: {
        permissions: ROLES,
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/omni/boletos'),
      name: 'omni_boletos',
      component: BoletosIndex,
      meta: {
        permissions: ROLES,
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/omni/wa-campaigns'),
      name: 'omni_wa_campaigns',
      component: WaCampaignsIndex,
      meta: {
        permissions: ROLES,
      },
    },
  ],
};

